export default class GalleryImagesSerializer {
    static unserialize(galleryImages) {
        galleryImages = galleryImages.sort((a, b) => a.position > b.position ? 1 : -1);
        return galleryImages;
    }
}


// WEBPACK FOOTER //
// ./web/src/services/gallery/GalleryImagesSerializer.js